/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import type AuthenticationSettingsType from '@jira/spa-apps__admin-pages-product-jsm-authentication-settings/src/AuthenticationSettingsType.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

export const LazyAuthenticationSettings: LazyComponent<() => React.JSX.Element> = lazyForPaint<
	typeof AuthenticationSettingsType
>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-admin-pages-jsm-authentication-settings", jiraSpaEntry: "async-admin-pages-jsm-authentication-settings" */ '@jira/spa-apps__admin-pages-product-jsm-authentication-settings/src/AuthenticationSettingsType.tsx'
		),
	),
);

const AsyncAuthenticationSettings = (): React.JSX.Element => (
	<LazyPage
		Page={LazyAuthenticationSettings}
		pageId="spa-apps/admin-pages/jsm-authentication-settings"
		shouldShowSpinner={false}
	/>
);

export default AsyncAuthenticationSettings;
